export const getPayloadBrokerage = (env: string) => {
  return {
    advWrapFeeDisclosure: {
      accepted: true,
      id: env === 'prod' ? 'articles/30883056088468' : 'articles/30874586279700',
    },
    customerRelationshipSummaryDisclosure: {
      accepted: true,
      id: env === 'prod' ? 'articles/30883058562964' : 'articles/30874628076820',
    },
    investmentProfile: {
      disclosure: {
        customerAccountAgreement: {
          accepted: true,
        },
        termsOfUse: {
          accepted: true,
        },
        privacyPolicy: {
          accepted: true,
        },
        marginAgreement: {
          accepted: true,
        },
        tradingDisclosure: {
          accepted: true,
        },
        cashManagementProgramDisclosure: {
          accepted: true,
        },
        batsSubscriberAgreement: {
          accepted: true,
        },
        nasdaqSubscriberAgreement: {
          accepted: true,
        },
        nyseAmexSubscriberAgreement: {
          accepted: true,
        },
        rule14b: {
          accepted: true,
        },
      },
    },
  }
}

export const getPayloadIRA = (env: string) => {
  return {
    advWrapFeeDisclosure: {
      accepted: true,
      id: env === 'prod' ? 'articles/30883056088468' : 'articles/30874586279700',
    },
    customerRelationshipSummaryDisclosure: {
      accepted: true,
      id: env === 'prod' ? 'articles/30883058562964' : 'articles/30874628076820',
    },
    investmentProfile: {
      disclosure: {
        iraCustomerAgreement: {
          accepted: true,
        },
        termsOfUse: {
          accepted: true,
        },
        privacyPolicy: {
          accepted: true,
        },
        tradingDisclosure: {
          accepted: true,
        },
        cashManagementProgramDisclosure: {
          accepted: true,
        },
        batsSubscriberAgreement: {
          accepted: true,
        },
        nasdaqSubscriberAgreement: {
          accepted: true,
        },
        nyseAmexSubscriberAgreement: {
          accepted: true,
        },
        rule14b: {
          accepted: true,
        },
      },
    },
  }
}
